import { Location } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import { SectionCard } from "./event-detail-section-card";

type EventLocationProps = Readonly<{
  location: string;
}>;

/**
 * The venue, as the organizer wrote it.
 *
 * This replaced an embedded Google/Leaflet map. Locations are now typed by hand
 * in the event form, so there are no coordinates to pin — an embed would centre
 * on 0,0 (the Atlantic) for every event created since. The text is selectable
 * so an address can still be copied into a maps app or a calendar invite.
 */
const EventLocation = ({ location }: EventLocationProps) => {
  const { t } = useTranslation();

  return (
    <SectionCard>
      <Text className="text-base font-semibold mb-2 text-onyx">
        {t("LABEL_LOCATION")}
      </Text>

      <View className="flex-row items-start gap-2">
        <View className="mt-0.5">
          <Location size={16} className="text-onyx" />
        </View>
        <Text className="text-sm flex-1 text-onyx" selectable>
          {location}
        </Text>
      </View>
    </SectionCard>
  );
};

export default EventLocation;
